import * as React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';

export const MultiSelectField = (props) => {
  const [selectedValues, setSelectedValues] = React.useState([]);
  const { id, name, hintText, menuItems, onListChange, disabled, renderValue, selectAll } = props;
	

  const handleChange = (event) => {
    const { // get the value from the event
      target: { value },
    } = event;
    if (selectAll && value.includes('All')) { // if "All" is selected, toggle between selecting all items and deselecting all items
      setSelectedValues(selectedValues.length === menuItems.length ? [] : menuItems.map(item => item.value));
    } else {
      // Ensure it's always an array
      setSelectedValues(typeof value === "string" ? value.split(",") : value);
    }
    if (onListChange) { // call the onListChange callback with the new value
      onListChange(typeof value === "string" ? value.split(",") : value);
    }
  };

  // Prevent the checkbox from toggling when clicking on it directly
  const _onCheck = (event) => {
		event.preventDefault();
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="multiple-select-label">{hintText}</InputLabel>
      <Select
        labelId={"multiple-select-label"}
        id={id}
        multiple
        value={selectedValues}
        onChange={handleChange}
        inputProps={{
          name
        }}
        disabled={disabled}
        renderValue={renderValue}
          >
        {selectAll && // if selectAll is true, add an "All" option at the top of the menu
        <MenuItem id='All' key='All' value='All'>
          <Checkbox checked={selectedValues.length === menuItems.length && menuItems.length > 0} />
          All
        </MenuItem>}
        {menuItems.map((item, i) => (
          <MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>
            <Checkbox checked={selectedValues.indexOf(item.value) > -1} onChange={_onCheck} />
            {item.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

